import { createSelector } from "@reduxjs/toolkit"

export const hasRelatedAssetsSelector = createSelector(
  [state => state.relatedAssets.assets],
   relatedAssets => Object.keys(relatedAssets).length > 0
)
